import React, {lazy} from 'react';
import { Redirect } from 'react-router';
import Auth from '../services/auth';
import AuthGuard from './AuthGuard';

import Login from '../pages/login/Login';
import ChangePassword from '../pages/login/ChangePassword';
import ForgotPassword from '../pages/login/ForgotPassword';
// const Login = lazy(() => import('../pages/login/Login'));
// const ChangePassword = lazy(() => import('../pages/login/ChangePassword'));
// const ForgotPassword = lazy(() => import('../pages/login/ForgotPassword'));;
const Profile = lazy(() => import('../pages/user/profile'));

/* DASHBOARD */
const DashboardExecutive = lazy(() => import('../pages/dashboard/executive/DashboardExecutive'));

/* CUSTOMER */
const FormInquiryData = lazy(() => import('../pages/customer/inquiryData/formInquiryData'));
const CustomerData = lazy(() => import('../pages/customer/customerData'));
const FormCustomerData = lazy(() => import('../pages/customer/customerData/formCustomerData'));

/* TELLER */
const TellerSavings = lazy(() => import('../pages/teller/savings'));
const TellerEquity = lazy(() => import('../pages/teller/equity'));
// import TellerSaving from '../pages/teller/saving';
const TellerWithdrawal = lazy(() => import('../pages/teller/withdrawal'));
const TellerFinPayment = lazy(() => import('../pages/teller/financingPayment'));
const TellerRepaymentList = lazy(() => import('../pages/teller/financing'));
const TellerSavingCollective = lazy(() => import('../pages/teller/savingCollective'));
const FormSavingCollective = lazy(() => import('../pages/teller/savingCollective/formSavingCollective'));
const TellerWithdrawalCollective = lazy(() => import('../pages/teller/withdrawalCollective'));
const FormWithdrawalCollective = lazy(() => import('../pages/teller/withdrawalCollective/formWithdrawalCollective'));

/* LOAN */
const MasterProduct = lazy(() => import('../pages/loan/masterProduct'));
const FormMasterProduct = lazy(() => import('../pages/loan/masterProduct/form'));
const LoanDataEntry = lazy(() => import('../pages/loan/loanDataEntry'));
const FormDataEntry = lazy(() => import('../pages/loan/loanDataEntry/formDataEntry'));
const LoanVerification = lazy(() => import('../pages/loan/loanVerification'));
const FormVerification = lazy(() => import('../pages/loan/loanVerification/formVerification'));
const LoanDisbursement = lazy(() => import('../pages/loan/loanDisbursement'));
const FormDisbursement = lazy(() => import('../pages/loan/loanDisbursement/formDisbursement'));
// Verifikasi Data SLIK
const SlikVerify = lazy(() => import('../pages/loan/slikVerify/slikVerify'));
const FormSlikVerify = lazy(() => import('../pages/loan/slikVerify/formSlikVerify'));
// Sumber Dana
const SourceOfFund = lazy(() => import('../pages/loan/sourceOfFund/sourceOfFund'));
const FormSourceOfFund = lazy(() => import('../pages/loan/sourceOfFund/formSourceOfFund'));
// Laporan
const LoanReportingFailedPayment = lazy(() => import('../pages/loan/loanReporting/failedPayment'));
// Pelunasan
const LoanRepaymentList = lazy(() => import('../pages/loan/loanRepayment'));
const LoanRepaymentSimulation = lazy(() => import('../pages/loan/loanRepaymentSimulation'));

// Collection
const MonitoringDebitur = lazy(() => import('../pages/collection/monitoringDebitur'));
const DetailMonitoringDebitur = lazy(() => import('../pages/collection/monitoringDebitur/detailMonitoringDebitur'));
//Approval Penerimaan Dana
const ApprovalFinancingReceiptList = lazy(() => import('../pages/loan/approvalFinancingReceipt'));

/* ASSETS */ 
const AssetsManagement = lazy(() => import('../pages/assets/assetsManagement'));
const FormAsset = lazy(() => import('../pages/assets/assetsManagement/formAsset'));

/* EQUITY */
const EquityReportingMutation = lazy(() => import('../pages/equity/reporting/mutation'));

/* ACCOUNTING */
//Neraca
const NeracaCabang  = lazy(() => import('../pages/accounting/neraca/neracaCabang/neracaCabang'));
const SHUCabang  = lazy(() => import('../pages/accounting/neraca/SHUCabang/SHUCabang'));
const NeracaGabungan  = lazy(() => import('../pages/accounting/neraca/neracaGabungan/neracaGabungan'));
const SHUGabungan  = lazy(() => import('../pages/accounting/neraca/SHUGabungan/SHUGabungan'));
const NeracaKonsolidasi  = lazy(() => import('../pages/accounting/neraca/neracaKonsolidasi/neracaKonsolidasi'));
const SHUKonsolidasi  = lazy(() => import('../pages/accounting/neraca/SHUKonsolidasi/SHUKonsolidasi'));
const NeracaKoperasi  = lazy(() => import('../pages/accounting/neraca/neracaKoperasi/neracaKoperasi'));
const SHUKoperasi  = lazy(() => import('../pages/accounting/neraca/SHUKoperasi/SHUKoperasi'));
const ArusKas  = lazy(() => import('../pages/accounting/neraca/arusKas/arusKas'));
const PerubahanEkuitas  = lazy(() => import('../pages/accounting/neraca/perubahanEkuitas/perubahanEkuitas'));
const DanaZakat  = lazy(() => import('../pages/accounting/neraca/danaZakat/danaZakat'));
const DanaKebajikan  = lazy(() => import('../pages/accounting/neraca/danaKebajikan/danaKebajikan'));
//
const BukuBesar  = lazy(() => import('../pages/accounting/bukuBesar/bukuBesar'));
const ListingJurnal  = lazy(() => import('../pages/accounting/listingJurnal/listingJurnal'));
const TransactionJournal  = lazy(() => import('../pages/accounting/transactionJournal'));
const FormTransactionJournal  = lazy(() => import('../pages/accounting/transactionJournal/formTransactionJournal'));
const TrialBalance  = lazy(() => import('../pages/accounting/trialBalance'));
const AccountingInsurance  = lazy(() => import('../pages/accounting/insurance'));
const PaymentInsurance  = lazy(() => import('../pages/accounting/insurance/paymentInsurance'));
// Rekonsiliasi
const RAKHarian  = lazy(() => import('../pages/accounting/reconciliation/RAKHarian/RAKHarian'));
const RAKBulanan  = lazy(() => import('../pages/accounting/reconciliation/RAKBulanan/RAKBulanan'));

/*SETTINGS*/
const UserManagement = lazy(() => import('../pages/settings/managementUser/userManagement'));
// Role Access
const RoleAccess = lazy(() => import('../pages/settings/managementRoleAccess/roleAccess'));
const MenuList = lazy(() => import('../pages/settings/managementRoleAccess/menuList'));
// Master Data
const MasterParameter = lazy(() => import('../pages/settings/masterParameter/masterParameter'));
const MasterBranch = lazy(() => import('../pages/settings/masterBranch/masterBranch'));
// Coa
const CoASetup = lazy(() => import('../pages/settings/coa/coaSetup'));
const CoAInitialBalanceSetup = lazy(() => import('../pages/settings/coa/initialBalanceSetup'));
const SetupJournalFinancingList = lazy(() => import('../pages/settings/coaSetupJournal/setupJournalFinancingList'));
const SetupJournalFinancingDetail = lazy(() => import('../pages/settings/coaSetupJournal/setupJournalFinancingDetail'));
/* ATTENDANCE */
const AttendanceSummary = lazy(() => import('../pages/attendance/attendanceSummary/attendanceSummary'));
const AttendanceSummaryUser = lazy(() => import('../pages/attendance/attendanceSummaryUser.js/attendanceSummaryUser'));

const auth = new Auth();
const isAuthenticated = auth.isAuthenticated();

const routes = [
  {
    path: '/',
    exact: true,
    component: () => isAuthenticated ? <Redirect to='/user/profile'/> : <Redirect to='/login'/>
  },
  {
    path: '/login',
    exact: true,
    title: 'Login',
    component: () => <Login />
  },
  {
    path: '/login/change-password',
    exact: true,
    title: 'Ubah Password',
    component: () => <ChangePassword />
  },
  {
    path: '/login/forgot-password',
    exact: true,
    title: 'Lupa Password',
    component: () => <ForgotPassword />
  },
  {
    path: '/home',
    exact: true,
    title: 'Home',
    component: () => <Redirect to='/user/profile'/>,
  },
  {
    path: '/user/profile',
    exact: true,
    title: 'Profile',
    component: AuthGuard(Profile),
  },
  //DASHBOARD
  {
    path: '/dashboard/dashboard-executive',
    exact: true,
    title: 'Dashboard Eksekutif',
    component: AuthGuard(DashboardExecutive),
  
  },
  //SETTINGS
  {
    path: '/settings/settings-user',
    exact: true,
    title: 'User Management',
    component: AuthGuard(UserManagement),
  },
  {
    path: '/settings/settings-role',
    exact: true,
    title: 'Role Management',
    component: AuthGuard(RoleAccess),
  },
  {
    path: '/settings/settings-role/list-menu',
    exact: true,
    title: 'Role Management List Menu',
    component: AuthGuard(MenuList),
  },
  {
    path: '/settings/master-data-parameter',
    exact: true,
    title: 'Master Parameter',
    component: AuthGuard(MasterParameter),
  },
  {
    path: '/settings/master-data-branch',
    exact: true,
    title: 'Master Kantor Cabang',
    component: AuthGuard(MasterBranch)
  },
  //SETTINGS COA
  {
    path: '/coa-data/coa-data-setup',
    exact: true,
    title: 'CoA Setup',
    component: AuthGuard(CoASetup),
  },
  {
    path: '/coa-data/coa-data-initial-balance',
    exact: true,
    title: 'Setup Saldo Awal',
    component: AuthGuard(CoAInitialBalanceSetup),
  },
  {
    path: '/coa-setup-journal/coa-setup-journal-financing',
    exact: true,
    title: 'Setup Jurnal Sumber Dana',
    component: AuthGuard(SetupJournalFinancingList),
  },
  {
    path: '/coa-setup-journal/coa-setup-journal-financing/detail',
    exact: true,
    title: 'Setup Jurnal Sumber Dana Detail',
    component: AuthGuard(SetupJournalFinancingDetail),
  },
  // Accounting
  {
    path: '/accounting-neraca/accounting-neraca-1',
    exact: true,
    title: 'Neraca Cabang',
    component: AuthGuard(NeracaCabang)
  },
  {
    path: '/accounting-neraca/accounting-neraca-2',
    exact: true,
    title: 'Neraca Gabungan',
    component: AuthGuard(NeracaGabungan)
  },
  {
    path: '/accounting-neraca/accounting-neraca-3',
    exact: true,
    title: 'Neraca Konsolidasi',
    component: AuthGuard(NeracaKonsolidasi)
  },
  {
    path: '/accounting-neraca/accounting-neraca-4',
    exact: true,
    title: 'Neraca Koperasi',
    component: AuthGuard(NeracaKoperasi)
  },
  {
    path: '/accounting-neraca/accounting-neraca-5',
    exact: true,
    title: 'Arus Kas',
    component: AuthGuard(ArusKas)
  },
  {
    path: '/accounting-neraca/accounting-neraca-6',
    exact: true,
    title: 'Perubahan EKuitas',
    component: AuthGuard(PerubahanEkuitas)
  },
  {
    path: '/accounting-neraca/accounting-neraca-7',
    exact: true,
    title: 'Sumber Dan Penggunaan Dana Zakat',
    component: AuthGuard(DanaZakat)
  },
  {
    path: '/accounting-neraca/accounting-neraca-8',
    exact: true,
    title: 'Sumber Dan Penggunaan Dana Kebajikan',
    component: AuthGuard(DanaKebajikan)
  },
  {
    path: '/accounting-neraca/accounting-neraca-9',
    exact: true,
    title: 'SHU Cabang',
    component: AuthGuard(SHUCabang)
  },
  {
    path: '/accounting-neraca/accounting-neraca-10',
    exact: true,
    title: 'SHU Gabungan',
    component: AuthGuard(SHUGabungan)
  },
  {
    path: '/accounting-neraca/accounting-neraca-11',
    exact: true,
    title: 'SHU Konsolidasi',
    component: AuthGuard(SHUKonsolidasi)
  },
  {
    path: '/accounting-neraca/accounting-neraca-12',
    exact: true,
    title: 'SHU Koperasi',
    component: AuthGuard(SHUKoperasi)
  },
  {
    path: '/accounting/accounting-general-ledger',
    exact: true,
    title: 'Buku Besar',
    component: AuthGuard(BukuBesar)
  },
  {
    path: '/accounting/accounting-general-journal',
    exact: true,
    title: 'Listing Jurnal',
    component: AuthGuard(ListingJurnal)
  },
  {
    path: '/accounting/accounting-transaction-journal',
    exact: true,
    title: 'Jurnal Transaksi',
    component: AuthGuard(TransactionJournal)
  },
  {
    path: '/accounting/accounting-transaction-journal/form',
    exact: true,
    title: 'Form Jurnal Transaksi',
    component: AuthGuard(FormTransactionJournal)
  },
  {
    path: '/accounting/accounting-transaction-journal-summary',
    exact: true,
    title: 'Trial Balance',
    component: AuthGuard(TrialBalance)
  },
  {
    path: '/accounting/accounting-insurance',
    exact: true,
    title: 'Asuransi',
    component: AuthGuard(AccountingInsurance)
  },
  {
    path: '/accounting/accounting-insurance/detail',
    exact: true,
    title: 'Pembayaran Asuransi',
    component: AuthGuard(PaymentInsurance)
  },
  {
    path: '/accounting-reconciliation/accounting-reconciliation-1',
    exact: true,
    title: 'RAK Harian',
    component: AuthGuard(RAKHarian),
  },
  {
    path: '/accounting-reconciliation/accounting-reconciliation-2',
    exact: true,
    title: 'RAK Bulanan',
    component: AuthGuard(RAKBulanan),
  },
  // LOAN
  {
    path: '/loan/loan-master-product',
    exact: true,
    title: 'Master Produk',
    component: AuthGuard(MasterProduct)
  },
  {
    path: '/loan/loan-master-product/detail',
    exact: true,
    title: 'Produk Detail',
    component: AuthGuard(FormMasterProduct)
  },
  {
    path: '/loan/loan-data-entry',
    exact: true,
    title: 'Data Entry',
    component: AuthGuard(LoanDataEntry)
  },
  {
    path: '/loan/loan-data-entry/form',
    exact: true,
    title: 'Form Data Entry',
    component: AuthGuard(FormDataEntry)
  },
  {
    path: '/loan/loan-verification',
    exact: true,
    title: 'Verifikasi Data',
    component: AuthGuard(LoanVerification)
  },
  {
    path: '/loan/loan-verification/form',
    exact: true,
    title: 'Form Verifikasi Data',
    component: AuthGuard(FormVerification)
  },
  {
    path: '/loan/loan-credit-disbursement',
    exact: true,
    title: 'Realisasi',
    component: AuthGuard(LoanDisbursement)
  },
  {
    path: '/loan/loan-credit-disbursement/detail',
    exact: true,
    title: 'Detail Realisasi',
    component: AuthGuard(FormDisbursement)
  },
  {
    path: '/loan/loan-verification-slik',
    exact: true,
    title: 'Verifikasi Data SLIK',
    component: AuthGuard(SlikVerify)
  },
  {
    path: '/loan/loan-verification-slik/form',
    exact: true,
    title: 'Form Verifikasi Data SLIK',
    component: AuthGuard(FormSlikVerify)
  },
  {
    path: '/loan/loan-batch-funds',
    exact: true,
    title: 'Sumber Dana',
    component: AuthGuard(SourceOfFund)
  },
  {
    path: '/loan/loan-batch-funds/form',
    exact: true,
    title: 'Form Sumber Dana',
    component: AuthGuard(FormSourceOfFund)
  },
  {
    path: '/loan-reporting/loan-reporting-failed-payment',
    exact: true,
    title: 'Laporan Gagal Bayar',
    component: AuthGuard(LoanReportingFailedPayment)
  },
  {
    path: '/loan/loan-repayment',
    exact: true,
    title: 'Pelunasan',
    component: AuthGuard(LoanRepaymentList),
  },
  {
    path: '/loan/loan-repayment-simulation',
    exact: true,
    title: 'Simulasi Pelunasan',
    component: AuthGuard(LoanRepaymentSimulation),
  },
  {
    path: '/loan/approval-financing-receipt',
    exact: true,
    title: 'Approval Penerimaan Dana',
    component: AuthGuard(ApprovalFinancingReceiptList),
  },
  //COLLECTION
  {
    path: '/collection/collection-monitoring-debitur',
    exact: true,
    title: 'Monitoring Debitur',
    component: AuthGuard(MonitoringDebitur)
  },
  {
    path: '/collection/collection-monitoring-debitur/detail',
    exact: true,
    title: 'Detail Monitoring Debitur',
    component: AuthGuard(DetailMonitoringDebitur)
  },
  //TELLER
  {
    path: '/teller-transaction/teller-transaction-savings',
    exact: true,
    title: 'Tabungan',
    component: AuthGuard(TellerSavings)
  },
  {
    path: '/teller-transaction/teller-transaction-equity',
    exact: true,
    title: 'Ekuitas',
    component: AuthGuard(TellerEquity)
  },
  {
    path: '/teller/teller-withdrawal',
    exact: true,
    title: 'Penarikan',
    component: AuthGuard(TellerWithdrawal)
  },
  {
    path: '/teller/teller-financing-payment',
    exact: true,
    title: 'Pembayaran Angsuran',
    component: AuthGuard(TellerFinPayment)
  },
  {
    path: '/teller-transaction/teller-transaction-financing',
    exact: true,
    title: 'Pelunasan Pembiayaan',
    component: AuthGuard(TellerRepaymentList)
  },
  {
    path: '/teller-transaction/teller-transaction-deposit-collective',
    exact: true,
    title: 'List Setoran Kolektif',
    component: AuthGuard(TellerSavingCollective)
  },
  {
    path: '/teller-transaction/teller-transaction-deposit-collective/form',
    exact: true,
    title: 'Form Setoran Kolektif',
    component: AuthGuard(FormSavingCollective)
  },
  {
    path: '/teller-transaction/teller-transaction-withdrawal-collective',
    exact: true,
    title: 'List Penarikan Kolektif',
    component: AuthGuard(TellerWithdrawalCollective)
  },
  {
    path: '/teller-transaction/teller-transaction-withdrawal-collective/form',
    exact: true,
    title: 'Form Penarikan Kolektif',
    component: AuthGuard(FormWithdrawalCollective)
  },
  //ASSETS
  {
    path: '/assets/assets-management',
    exact: true,
    title: 'Manajemen Aset',
    component: AuthGuard(AssetsManagement)
  },
  {
    path: '/assets/assets-management/form',
    exact: true,
    title: 'Form Aset',
    component: AuthGuard(FormAsset)
  },
  //ATTENDANCE
  {
    path: '/attendance/attendance-summary',
    exact: true,
    title: 'Rekapitulasi Kehadiran Harian',
    component: AuthGuard(AttendanceSummary)
  },
  {
    path: '/attendance/attendance-summary-detail',
    exact: true,
    title: 'Rekapitulasi Kehadiran User Detail',
    component: AuthGuard(AttendanceSummaryUser)
  },
  //CUSTOMER
  // {
  //   path: '/customer/customer-inquiry-data',
  //   exact: true,
  //   title: 'Inquiry Data',
  //   component: AuthGuard(CustomerInquiryData)
  // },
  // {
  //   path: '/customer/customer-inquiry-data/detail',
  //   exact: true,
  //   title: 'Inquiry Data Detail',
  //   component: AuthGuard(FormInquiryData)
  // },
  {
    path: '/customer/customer-data',
    exact: true,
    title: 'Data Anggota',
    component: AuthGuard(CustomerData)
  },
  {
    path: '/customer/customer-data/form',
    exact: true,
    title: 'Form Anggota',
    component: AuthGuard(FormCustomerData)
  },
  {
    path: '/customer/customer-data/detail',
    exact: true,
    title: 'Detail Anggota',
    component: AuthGuard(FormCustomerData)
  },
  {
    path: '/customer/customer-data/detail/loan',
    exact: true,
    title: 'Pembiayaan Detail',
    component: AuthGuard(FormInquiryData)
  },
  //EQUITY
  {
    path: '/equity-reporting/equity-reporting-mutation',
    exact: true,
    title: 'Mutasi',
    component: AuthGuard(EquityReportingMutation)
  },
];

export default routes;